import { motion } from "framer-motion";
import { WhatsappLogo, ArrowDown } from "@phosphor-icons/react";
import { waLink } from "../../data/site";

const lineVariants = {
    hidden: { y: "110%" },
    show: (i) => ({
        y: "0%",
        transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
    }),
};

const HERO_IMG =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_sangkar-premium/artifacts/51ukibri_18189.jpg";

export const Hero = () => {
    const lines = ["Astana Selesa", "Untuk Si Bulus", "Kesayangan Anda"];

    return (
        <section
            id="top"
            data-testid="hero"
            className="relative min-h-screen pt-[74px] overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-12 gap-10 items-center min-h-[calc(100vh-74px)]">
                <div className="lg:col-span-7 pt-10 lg:pt-0">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.6 }}
                        className="flex items-center gap-3 mb-8"
                    >
                        <span className="h-px w-10 bg-accent" />
                        <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-accent">
                            Sangkar &amp; Catio Kucing Premium · Malaysia
                        </span>
                    </motion.div>

                    <h1 className="font-display text-[13vw] leading-[0.92] sm:text-6xl lg:text-[5.4rem] lg:leading-[0.95] tracking-tight text-ink" aria-label="Astana Selesa Untuk Si Bulus Kesayangan Anda">
                        {lines.map((line, i) => (
                            <span key={i} className="block overflow-hidden" aria-hidden="true">
                                <motion.span
                                    className="block"
                                    custom={i}
                                    variants={lineVariants}
                                    initial="hidden"
                                    animate="show"
                                >
                                    {i === 1 ? (
                                        <em className="not-italic text-accent font-medium italic">{line}</em>
                                    ) : (
                                        line
                                    )}
                                </motion.span>
                            </span>
                        ))}
                    </h1>

                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.7 }}
                        className="mt-8 max-w-xl text-base md:text-lg text-ink-soft leading-relaxed"
                    >
                        Sangkar, catio kayu/besi kustom &amp; rumah kucing luar rumah —
                        dibina kukuh, berpengudaraan baik dan estetik. Kediaman selamat
                        yang si kucing anda benar-benar layak dapat.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.85 }}
                        className="mt-10 flex flex-wrap items-center gap-4"
                    >
                        <a
                            href="#katalog"
                            data-testid="hero-catalog-cta"
                            className="rounded-full border border-border px-7 py-3.5 text-sm font-semibold text-ink hover:bg-surface transition-colors duration-300"
                        >
                            Lihat Katalog
                        </a>
                        <a
                            href={waLink("Hai ASTANA KUCING'S, saya berminat untuk menempah. Boleh bantu?")}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="hero-whatsapp-cta"
                            className="group inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300"
                        >
                            <WhatsappLogo size={19} weight="fill" />
                            Tempah Menerusi WhatsApp
                        </a>
                    </motion.div>
                </div>

                <div className="lg:col-span-5">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                        className="relative border border-border bg-white"
                    >
                        <img
                            src={HERO_IMG}
                            alt="Katalog ASTANA KUCING'S 2026 – 2027"
                            className="block w-full h-auto"
                        />
                    </motion.div>
                </div>
            </div>

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex items-center gap-2 text-ink-soft">
                <ArrowDown size={16} />
                <span className="font-mono text-[10px] uppercase tracking-[0.28em]">Skrol</span>
            </div>
        </section>
    );
};
